import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-323213b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "banner-tips" }
const _hoisted_4 = { class: "g-card order-form" }
const _hoisted_5 = { class: "form-header" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "g-checkbox pointer",
  for: "isDefault"
}, " 设为默认收货地址 ", -1))
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("text", null, "收件国家/地区"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " Country/Region ")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "g-input",
  "placeholder-class": "g-input__placeholder",
  placeholder: "填写收件人英文名字",
  type: "text"
}
const _hoisted_11 = { class: "form-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("text", null, "收件人"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " name ")
], -1))
const _hoisted_13 = { class: "form-item-input" }
const _hoisted_14 = { class: "form-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, [
  /*#__PURE__*/_createElementVNode("text", null, "联系电话"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " Phone No. ")
], -1))
const _hoisted_16 = { class: "form-item-input with-prefix" }
const _hoisted_17 = { class: "input-prefix" }
const _hoisted_18 = { class: "form-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("text", null, "邮编"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " ZIP Code ")
], -1))
const _hoisted_20 = { class: "form-item-input" }
const _hoisted_21 = { class: "form-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("text", null, "州"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " State ")
], -1))
const _hoisted_23 = {
  class: "g-input",
  type: "text"
}
const _hoisted_24 = { class: "form-item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("text", null, "城市"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " City ")
], -1))
const _hoisted_26 = { class: "form-item-input" }
const _hoisted_27 = { class: "form-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("text", null, "地址1"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " Address line 1 ")
], -1))
const _hoisted_29 = { class: "form-item-input" }
const _hoisted_30 = { class: "form-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, [
  /*#__PURE__*/_createElementVNode("text", null, "地址2"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " Address line 2 ")
], -1))
const _hoisted_32 = { class: "form-item-input" }
const _hoisted_33 = { class: "footer-ctrl g-fixed" }
const _hoisted_34 = { class: "footer" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_CountryPicker = _resolveComponent("CountryPicker")!
  const _component_Picker = _resolveComponent("Picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, {
          class: "icon",
          icon: "icon_warning"
        }),
        _createTextVNode("收件人信息请用英文填写 ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isDefault) = $event)),
            type: "checkbox",
            value: "1",
            id: "isDefault",
            checked: _ctx.form.isDefault === _ctx.IsDefaultUserAddress.Default
          }, null, 8, _hoisted_6), [
            [_vModelCheckbox, _ctx.form.isDefault]
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", {
            class: "form-item-input pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCountryPicker && _ctx.showCountryPicker(...args)))
          }, [
            (_ctx.displayCountryInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.displayCountryInfo.name) + " " + _toDisplayString(_ctx.displayCountryInfo.nameCn), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.firstname) = $event)),
              "placeholder-class": "g-input__placeholder",
              placeholder: "填写收件人英文名字",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.form.firstname]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.phonePrefix), 1),
            _withDirectives(_createElementVNode("input", {
              class: "g-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.mobile) = $event)),
              "placeholder-class": "g-input__placeholder",
              placeholder: "填写收件人联系电话",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.form.mobile]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.zipcode) = $event)),
              "placeholder-class": "g-input__placeholder",
              placeholder: "填写收件邮编",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.form.zipcode]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", {
            class: "form-item-input pointer",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showTownPicker && _ctx.showTownPicker(...args)))
          }, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.displayTownInfo ? _ctx.displayTownInfo.name : ''), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.city) = $event)),
              "placeholder-class": "g-input__placeholder",
              placeholder: "填写收件城市的英文名称",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.form.city]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.address1) = $event)),
              "placeholder-class": "g-input__placeholder",
              placeholder: "填写英文收件地址1",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.form.address1]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.address2) = $event)),
              "placeholder-class": "g-input__placeholder",
              placeholder: "填写英文收件地址2",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.form.address2]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", {
          class: "g-button g-button-primary",
          "hover-class": "hover",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveAddress(_ctx.form)))
        }, " 保存 ")
      ])
    ]),
    _createVNode(_component_CountryPicker, {
      modelValue: _ctx.form.country,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.country) = $event)),
      "is-show-picker": _ctx.isShowCountryPicker,
      onCancel: _ctx.onCloseCountryPicker
    }, null, 8, ["modelValue", "is-show-picker", "onCancel"]),
    (_ctx.townList)
      ? (_openBlock(), _createBlock(_component_Picker, {
          key: 0,
          "is-hide-header": true,
          options: _ctx.townList,
          "is-show-picker": _ctx.isShowTownPicker,
          modelValue: _ctx.form.state,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.state) = $event)),
          onCancel: _ctx.onCloseTownPicker
        }, {
          footer: _withCtx(({ option }) => [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", {
                class: "g-button g-button-primary cancel",
                onClick: option.cancel
              }, " 取消 ", 8, _hoisted_35),
              _createElementVNode("div", {
                class: "g-button g-button-primary confirm",
                onClick: option.confirm
              }, " 确认 ", 8, _hoisted_36)
            ])
          ]),
          _: 1
        }, 8, ["options", "is-show-picker", "modelValue", "onCancel"]))
      : _createCommentVNode("", true)
  ]))
}